import { z } from 'zod'
import { DEFAULT_TAX_ROUNDING_STRATEGY, TaxRoundingStrategySchema } from './TaxConfigurations'

export const PriceEngineOptionsSchema = z.object({
  taxRoundingStrategy: TaxRoundingStrategySchema,
})

export type PriceEngineOptions = z.infer<typeof PriceEngineOptionsSchema>
export const DEFAULT_PRICE_ENGINE_OPTIONS: PriceEngineOptions = {
  taxRoundingStrategy: DEFAULT_TAX_ROUNDING_STRATEGY,
}
